import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFilter } from "../Redux/Auctions/AuctionsSlice";
import AuctionFilter from "../components/AuctionFilter";
import EventsList from "../components/EventsList";
import FilterButton from "../components/FilterButton";
import { filterResponsive, rightResponsive } from "../common/cssclasses";
import { checkIsReturning, consumeReturnTicket } from "../helper/pageFilterPersistence";

const initialAuctionFilters = {
  auctionName: "",
  auctionType: "None",
  auctionStartDateFrom: "",
  auctionStartDateTo: "",
  skip: 0,
  take: 6,
  numberOfHorsesFrom: 1,
  numberOfHorsesTo: 50,
  dateRange: null,
  enrolledAuction: false,
  reset: false,
};

const clearAuctionSessionStorage = () => {
  sessionStorage.removeItem("auc_filters");
  sessionStorage.removeItem("auc_return_from_details");
};

export default function AuctionPage() {
  const navigationType = useNavigationType();
  const location = useLocation();
  const prevLocationKey = useRef(location.key);
  const isInitialMount = useRef(true);
  const wasReturningRef = useRef(false);
  const dispatch = useDispatch();

  if (isInitialMount.current) {
    isInitialMount.current = false;
    const isReturning = checkIsReturning("auc_return_from_details", navigationType, "auction");
    wasReturningRef.current = isReturning;
    if (!isReturning) {
      clearAuctionSessionStorage();
    }
  }

  const [showFilter, setShowFilter] = useState(false); // Initially hide filter
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [filters, setFilters] = useState(() => {
    const saved = sessionStorage.getItem("auc_filters");
    return saved ? JSON.parse(saved) : initialAuctionFilters;
  });

  useEffect(() => {
    if (wasReturningRef.current) {
      consumeReturnTicket("auc_return_from_details");
    } else {
      dispatch(resetFilter());
    }
  }, [dispatch]);

  // Persist filter changes
  useEffect(() => {
    sessionStorage.setItem("auc_filters", JSON.stringify(filters));
  }, [filters]);

  // Re-clicking menu resets to default
  useEffect(() => {
    if (prevLocationKey.current !== location.key) {
      prevLocationKey.current = location.key;
      if (navigationType === "PUSH") {
        clearAuctionSessionStorage();
        setFilters(initialAuctionFilters);
        dispatch(resetFilter());
      }
    }
  }, [location.key, navigationType, dispatch]);

  const updateAuctionList = (newFilters) => {
    setFilters({ ...newFilters, reset: true });
  };

  const resetAuctionList = () => {
    clearAuctionSessionStorage();
    dispatch(resetFilter());
    setFilters({ ...initialAuctionFilters, reset: true });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Function to toggle filter visibility
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  return (
    <React.Fragment>

      <div className="row rtl">
        {/* Button to toggle filter visibility */}
        {windowWidth < 768 && (
          <div className="col-md-4 col-sm-6 col-6 text-center d-flex justify-content-center mb-3 mx-auto">
            <FilterButton onClick={toggleFilter} />
          </div>
        )}


        <div
          className={filterResponsive}
          style={{
            display:
              windowWidth >= 768 ? "block" : showFilter ? "block" : "none"
          }}
        >
          <AuctionFilter onSubmit={updateAuctionList} onReset={resetAuctionList} currentFilters={filters} />
        </div>
        <div className={rightResponsive}>
          <EventsList filters={filters} />
        </div>


      </div>

    </React.Fragment>
    // <ComingSoon />
  );
}
